export default __webpack_public_path__ + "static/media/dash_5.a4b58755.png";